/** @format */

import { InjectionToken } from '@angular/core';

/**
 * Configuration options for the PerformanceService.
 */
export interface PerformanceConfig {
  /**
   * Whether to automatically initialize the LCP observer when the service is constructed.
   * @default true
   */
  autoInitialize?: boolean;

  /**
   * Whether to dispatch the LCP event immediately upon determining the LCP entry.
   * @default true
   */
  dispatchLCPEventImmediately?: boolean;
}

/**
 * Injection token for PerformanceService configuration.
 * Provides default values when not explicitly configured.
 * By default, autoInitialize is true and dispatchLCPEventImmediately is true,
 * meaning the LCP observer starts automatically and the LCP event is dispatched as soon as determined.
 */
export const PERFORMANCE_CONFIG = new InjectionToken<PerformanceConfig>('PerformanceConfig', {
  providedIn: 'root',
  factory: () => ({
    autoInitialize: true,
    dispatchLCPEventImmediately: true,
  }),
});
